/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './message';

/**
 * 
 * @export
 * @interface WsMessageUpdated
 */
export interface WsMessageUpdated {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsMessageUpdated
     */
    type: string | null;
    /**
     * 
     * @type {Message}
     * @memberof WsMessageUpdated
     */
    message: Message;
}

/**
 * Check if a given object implements the WsMessageUpdated interface.
 */
export function instanceOfWsMessageUpdated(value: object): value is WsMessageUpdated {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WsMessageUpdatedFromJSON(json: any): WsMessageUpdated {
    return WsMessageUpdatedFromJSONTyped(json, false);
}

export function WsMessageUpdatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsMessageUpdated {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'message': MessageFromJSON(json['message']),
    };
}

export function WsMessageUpdatedToJSON(json: any): WsMessageUpdated {
    return WsMessageUpdatedToJSONTyped(json, false);
}

export function WsMessageUpdatedToJSONTyped(value?: WsMessageUpdated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'message': MessageToJSON(value['message']),
    };
}

